module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAOCAYAAAA1+Nx+AAAAAXNSR0IArs4c6QAAAI1JREFUOBHNk9ENQDAURTuEmIJRLGAaY1iGHSSGMISkzhOlP6Xt64ebXE+oc0TUWGsbOtHKFAqsQXriOJmpZKFqCQyBS3baGg41XalEJeF5H97fH4QbakkQ7iwaySdcI4mG50iS4SmSbHiMRA1/kxSDByQbAolsouc/d4tzJzB/n5SFu5e6JCOzc9d+MQ/VNWijinjIuAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/layouts/PageLayout/assets/dropdown@2x.png
// module id = ./src/layouts/PageLayout/assets/dropdown@2x.png
// module chunks = 1